import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getKanbanOrders = (params = {}) => apiActionCreator({
  'endpoint': `/accessories/kanban${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_KANBAN_ORDERS,
    {
      'type': ActionTypes.FETCHED_KANBAN_ORDERS,
    },
    [
      ActionTypes.FETCHED_KANBAN_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getKanbanOrderDetail = (orderId) => apiActionCreator({
  'endpoint': `/accessories/kanban/${orderId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_KANBAN_ORDER_DETAIL,
    {
      'type': ActionTypes.FETCHED_KANBAN_ORDER_DETAIL,
    },
    [
      ActionTypes.FETCHED_KANBAN_ORDER_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
